import { Http } from '@samknows/utils';
import { TosConfig, volunteersConfig } from '@/common/volunteers.config';
import { getUserOrganisationOwnerId } from '@/common/services/account/userSession';

export interface UserTOS {
  tosVersion: string;
  accepted: boolean;
  locale: string;
  timestamp: number;
}

export function getUserTOSConfig(): TosConfig {
  const userOwnerId = getUserOrganisationOwnerId();
  return volunteersConfig[userOwnerId]?.tos;
}

export function fetchUserTOS(): Promise<void> {
  return Http.request(`/ajax/settings/account/user/tos`, {
    useAuth: false
  });
}

export async function updateUserTOS(updatedTOS: UserTOS): Promise<void> {
  await Http.request(`/ajax/settings/account/user/tos`, {
    method: 'POST',
    body: JSON.stringify(updatedTOS),
    useAuth: false
  });
}
